import { Attendance } from "@/@types/esus/Attendance";
import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensAttendancesIndicatorC2Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenAttendancesIndicatorC2Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	firstAttendanceStatus: "finished" | "pending" | "lost" = "lost";
	nineAttendancesStatus: "finished" | "pending" | "lost" = "lost";
	nineWeightAndHeightMetricsRegistersStatus: "finished" | "pending" | "lost" = "lost";
	attendances?: Attendance[];
	weightAndHeightMetricsRegisters?: Attendance[];
	firstAttendance?: Attendance;
}

export async function getDetailedCitizensAttendancesIndicatorC2({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAttendancesIndicatorC2Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAttendancesIndicatorC2Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c2/detailed-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAttendancesIndicatorC2Data>();
}
